// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".force-ltr-input[data-v-58879edf] input,.force-ltr-input[data-v-58879edf] textarea{text-align:left!important;direction:ltr!important}.force-ltr-input[data-v-58879edf] .v-label{left:0!important;right:auto!important;-webkit-transform-origin:top left!important;transform-origin:top left!important;text-align:left!important}.force-ltr-input[data-v-58879edf] .v-messages,.force-ltr-input[data-v-58879edf] legend{text-align:left!important}", ""]);
// Exports
module.exports = exports;
